import { SERVICES_PROVIDER_CARD_DATA } from "const/data-solution";
import Image from "next/image";
import Container from "../common/Container";
import Title from "../common/Title";
import ViewMore from "../common/ViewMore";

const ServicesProvider = () => (
  <Container small className="bg-primary-black py-36 md:py-40 ">
    <Title
      description="Experience a transformative journey to success with ultroNeous, your definitive web scraping partner, offering cutting-edge solutions that elevate your data-driven strategies and outcomes."
      descriptionClass="text-base text-white text-center xl:px-12 xl:mx-12 pb-28 md:pb-40"
      subTitle="Elevate Your Success with ultroNeous: The Ultimate Web Scraping Partner"
      subTitleClass="text-4xl md:text-6xl text-white text-center mb-6 xl:pb-2 leading-snug font-medium"
    />
    <div className="flex flex-col md:flex-row gap-6 leading-snug">
      {SERVICES_PROVIDER_CARD_DATA.map((value) => (
        <div
          key={value.id}
          className="text-center rounded-2xl relative px-6 transition-all duration-1000 ease-out hover:ease-in md:hover:scale-110 pt-24 md:pt-20 pb-8 w-full md:w-[353px] mb-20 md:mb-0 last:mb-0 bg-[rgba(44,36,36,0.5)] "
        >
          <div className="absolute left-1/2 -top-16 -translate-x-1/2">
            <Image alt={value.alt} height={130} src={value.src} width={129} />
          </div>
          <h3 className="text-white text-center font-normal mb-4 xl:mb-0 md:pb-4 text-xl md:text-2xl">
            <span>{value.title}</span>
          </h3>
          <p className="text-white text-sm md:text-base text-center pb-6 xl:pb-0 font-light min-h-5 md:min-h-40">
            <span>{value.description}</span>
          </p>
          <ViewMore
            arrow
            className="text-xl font-500 text-center text-primary-yellow"
            height={22}
            link={value.link}
            linkText="Read More"
            spanClass="pl-1"
            width={22}
          />
        </div>
      ))}
    </div>
  </Container>
);

export default ServicesProvider;
